import { render, staticRenderFns } from "./AppStoreSidebar.vue?vue&type=template&id=ffae2952&scoped=true"
import script from "./AppStoreSidebar.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppStoreSidebar.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AppStoreSidebar.vue?vue&type=style&index=0&id=ffae2952&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffae2952",
  null
  
)

export default component.exports